import { Component } from "react";
import { SliderSettings, TicketType, TransportationType, TransportationMethod } from "../Constant";
import MyContext from "./MyContext";
import { withTranslation } from "react-i18next";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import sv from "date-fns/locale/sv";

export class MyProvider extends Component {
  constructor(props) {
    super(props);
    this.state = {
      stops: [],
      lines: [],
      allowFileUploadExtension: props.allowFileUploadExtension,
      totalCostSEKMax: props.totalCostSEKMax,
      activeSlide: SliderSettings.initialSlide,
      caseNumber: "",
      ...this.getInitialState(),
    };
  }
  // state = this.getInitialState();

  getInitialState = () => ({
    /* state props */
    // allowFileUploadExtension: props.allowFileUploadExtension,
    registrationNumber: "",
    otherComments: "",
    fromAddress: "",
    toAddress: "",
    numberOfKmDriven: "",
    transportationType: TransportationType.USEOWNCAR,
    ticketType: TicketType.SINGLE,
    ticketId: null,
    accommodationTotalCost: "",
    foodTotalCost: "",
    transportTotalCost: "",
    personalID: "",
    mobileNumber: "",
    firstname: "",
    surname: "",
    streetNameAndNumber: "",
    postalCode: "",
    city: "",
    biljettnummerValue: "",
    from: null,
    to: null,
    departureDate: null,
    departureTime: null,
    email: "",
    username: "",
    bankAccountNumber: "",
    clearingNumber: "",
    foodReceipt: [],
    transportReceipt: [],
    accommodationReceipt: [],
    departureTimeOptions: null,
    declareInformation: false,
    consensus: false,
    distance: {},
    accounts: [],
    otherTicketTypeValue: "",
    transportationMethod: TransportationMethod.BUS,
    line: null
  });

  resetState = () => {
    this.setState(this.getInitialState());
  };

  locales = { en: undefined, sv };

  render() {
    const currentLocale = this.locales[this.props.i18n.language];
    return (
      <MyContext.Provider
        value={{
          bankAccountNumber: this.state.bankAccountNumber,
          changeBankAccountNumber: (bankAccountNumber) => {
            this.setState({ bankAccountNumber });
          },
          clearingNumber: this.state.clearingNumber,
          changeClearingNumber: (clearingNumber) => {
            this.setState({ clearingNumber });
          },
          status: this.state.status,
          changeStatus: (status) => {
            this.setState({ status });
          },
          activeSlide: this.state.activeSlide,
          changeActiveSlide: (activeSlide) => {
            this.setState({ activeSlide });
          },
          registrationNumber: this.state.registrationNumber,
          changeRegistrationNumber: (registrationNumber) => {
            this.setState({ registrationNumber });
          },
          totalCostSEKMax: this.state.totalCostSEKMax,
          changeTotalCostSEKMax: (totalCostSEKMax) => {
            this.setState({ totalCostSEKMax });
          },
          distance: this.state.distance,
          changeDistance: (distance) => {
            this.setState({ distance });
          },
          allowFileUploadExtension: this.state.allowFileUploadExtension,
          changeAllowFileUploadExtension: (allowFileUploadExtension) => {
            this.setState({ allowFileUploadExtension });
          },
          consensus: this.state.consensus,
          changeConsensus: (consensus) => {
            this.setState({ consensus });
          },
          declareInformation: this.state.declareInformation,
          changeDeclareInformation: (declareInformation) => {
            this.setState({ declareInformation });
          },
          departureTimeOptions: this.state.departureTimeOptions,
          changeDepartureTimeOptions: (departureTimeOptions) => {
            this.setState({ departureTimeOptions });
          },
          stops: this.state.stops,
          changeStops: (stops) => {
            this.setState({ stops });
          },
          lines: this.state.lines,
          changeLines: (lines) => {
            this.setState({ lines });
          },
          transportationType: this.state.transportationType,
          changeTransportationType: (transportationType) => {
            this.setState({ transportationType });
          },
          fromAddress: this.state.fromAddress,
          changeFromAddress: (fromAddress) => {
            this.setState({ fromAddress });
          },
          toAddress: this.state.toAddress,
          changeToAddress: (toAddress) => {
            this.setState({ toAddress });
          },
          numberOfKmDriven: this.state.numberOfKmDriven,
          changeNumberOfKmDriven: (numberOfKmDriven) => {
            this.setState({ numberOfKmDriven });
          },
          ticketType: this.state.ticketType,
          changeTicketType: (ticketType) => {
            this.setState({ ticketType });
          },
          ticketId: this.state.ticketId,
          changeTicketId: (ticketId) => {
            this.setState({ ticketId });
          },
          accommodationTotalCost: this.state.accommodationTotalCost,
          changeAccommodationTotalCost: (accommodationTotalCost) => {
            this.setState({ accommodationTotalCost });
          },
          transportTotalCost: this.state.transportTotalCost,
          changeTransportTotalCost: (transportTotalCost) => {
            this.setState({ transportTotalCost });
          },
          foodTotalCost: this.state.foodTotalCost,
          changeFoodTotalCost: (foodTotalCost) => {
            this.setState({ foodTotalCost });
          },
          personalID: this.state.personalID,
          changePersonalID: (personalID) => {
            this.setState({ personalID });
          },
          mobileNumber: this.state.mobileNumber,
          changeMobileNumber: (mobileNumber) => {
            this.setState({ mobileNumber });
          },
          streetNameAndNumber: this.state.streetNameAndNumber,
          changeStreetNameAndNumber: (streetNameAndNumber) => {
            this.setState({ streetNameAndNumber });
          },
          postalCode: this.state.postalCode,
          changePostalCode: (postalCode) => {
            this.setState({ postalCode });
          },
          city: this.state.city,
          changeCity: (city) => {
            this.setState({ city });
          },
          surname: this.state.surname,
          changeSurname: (surname) => {
            this.setState({ surname });
          },
          firstname: this.state.firstname,
          changeFirstname: (firstname) => {
            this.setState({ firstname });
          },
          departureDate: this.state.departureDate,
          changeDepartureDate: (departureDate) => {
            this.setState({ departureDate });
          },
          departureTime: this.state.departureTime,
          changeDepartureTime: (departureTime) => {
            this.setState({ departureTime });
          },
          email: this.state.email,
          changeEmail: (email) => {
            this.setState({ email });
          },
          biljettnummerValue: this.state.biljettnummerValue,
          changeBiljettnummerValue: (biljettnummerValue) => {
            this.setState({ biljettnummerValue });
          },
          from: this.state.from,
          changeFrom: (from) => {
            this.setState({ from });
          },
          to: this.state.to,
          changeTo: (to) => {
            this.setState({ to });
          },
          username: this.state.username,
          changeUsername: (username) => {
            this.setState({ username });
          },
          otherComments: this.state.otherComments,
          changeOtherComments: (otherComments) => {
            this.setState({ otherComments });
          },
          foodReceipt: this.state.foodReceipt,
          changeFoodReceipt: (foodReceipt) => {
            this.setState({ foodReceipt });
          },
          transportReceipt: this.state.transportReceipt,
          changeTransportReceipt: (transportReceipt) => {
            this.setState({ transportReceipt });
          },
          accommodationReceipt: this.state.accommodationReceipt,
          changeAccommodationReceipt: (accommodationReceipt) => {
            this.setState({ accommodationReceipt });
          },
          accounts: this.state.accounts,
          changeAccounts: (accounts) => {
            this.setState({ accounts });
          },
          caseNumber: this.state.caseNumber,
          changeCaseNumber: (caseNumber) => {
            this.setState({ caseNumber });
          },
          otherTicketTypeValue: this.state.otherTicketTypeValue,
          changeOtherTicketTypeValue: (otherTicketTypeValue) => {
            this.setState({ otherTicketTypeValue });
          },
          transportationMethod: this.state.transportationMethod,
          changeTransportationMethod: (transportationMethod) => {
            this.setState({ transportationMethod });
          },
          line: this.state.line,
                changeLine: (line) => {
                    this.setState({ line });
          },
          resetState: () => {
            this.resetState();
          },
        }}
      >
        <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={currentLocale}>
          {this.props.children}
        </LocalizationProvider>
      </MyContext.Provider>
    );
  }
}

export default withTranslation()(MyProvider);
